<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oBcTqB/tc-custom/9780253046321.jpg?1737782421867" alt="This image is the cover for the book Spanish Cinema Against Itself, New Directions in National Cinemas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spanish Cinema Against Itself, New Directions in National Cinemas
      </h1>
      <p class="bookDescription body article font2">
        <b>“An extraordinary philosophical exploration of the political potential and continued political commitment of cinema today . . . An essential read.” —Patricia Keller, Associate Professor of Spanish and Comparative Literature, Cornell University</b><br/><br/>Spanish Cinema Against Itself maps the evolution of Spanish surrealist and politically committed cinematic traditions from their origins in the 1930s—with the work of Luis Buñuel and Salvador Dalí, experimentalist José Val de Omar, and militant documentary filmmaker Carlos Velo—through to the contemporary period. Framed by film theory this book traces the works of understudied and non-canonical Spanish filmmakers, producers, and film collectives to open up alternate, more cosmopolitan and philosophical spaces for film discussion. In an age of the post-national and the postcinematic, Steven Marsh’s work challenges conventional historiographical discourse, the concept of “national cinema,” and questions of form in cinematic practice.<br/><br/><b>“In this exhilarating counter-history of experimental filmmaking in Spain, Steven Marsh takes up the politics of form, the trouble with film history, and the theoretical potential of haunting, discontinuity, and absence . . . <i>Spanish Cinema Against Itself</i> is an important intervention in Spanish film studies and, indeed, in the scholarship on world cinema.” —Rosalind Galt, Professor of Film Studies, King’s College London</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven Marsh
      </h2>
      
      <p class="authorDescription body article"><P>Steven Marsh is Professor of Spanish Film and Cultural Studies at the University of Illinois at Chicago. He is author of <I>Popular Spanish Film Under Franco: Comedy and the Weakening of the State</I> and editor (with Parvati Nair) of <I>Gender and Spanish Cinema</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28cf6761